import React from 'react'
import SVG from 'react-inlinesvg'
import caretIcon from 'images/caret-down.svg'
import { Collapse } from 'react-collapse'
import classNames from 'classnames'

const renderOptionImage = productCardPhoto => {
  return (
    <div className="overflow-hidden">
      <div
        style={{
          height: '150px',
          backgroundSize: 'cover',
          backgroundPosition: '80%',
          // prettier-ignore
          backgroundImage: `url(${productCardPhoto})`
        }}
      />
    </div>
  )
}

const PreviewButton = ({ name, isExpanded, onClick }) => {
  return (
    <button
      id={`expand-panel-${name}`}
      onClick={onClick}
      className="flex justify-between w-full text-left"
      data-testid="expand-button"
      aria-expanded={isExpanded}
      aria-controls={`event-${name}`}
      style={{ outlineOffset: -3 }}
    >
      <h3 className="text-depths">{name}</h3>

      <span
        className="border border-depths rounded-full flex w-32 h-32 flex-shrink-0 ml-8"
        style={{ opacity: isExpanded ? 0 : 1 }}
      >
        <SVG
          src={caretIcon}
          className="m-auto"
          aria-hidden="true"
          alt="caret down"
        />
      </span>
    </button>
  )
}

const TicketOption = ({
  preview,
  name,
  productCardPhoto,
  description,
  link,
  linkText,
  onClick,
  previewText
}) => {
  const style = {
    transition: 'opacity 300ms linear',
    opacity: preview ? 1 : 0
  }

  return (
    <div className="bordered-content p-0 overflow-hidden relative">
      <Collapse isOpened={preview}>
        {renderOptionImage(productCardPhoto, !!preview)}
      </Collapse>

      <div
        id={`ticket-${link}`}
        className="p-16 md:p-24 overflow-hidden"
        role="region"
      >
        <PreviewButton
          name={name}
          isExpanded={preview}
          description={description}
          onClick={onClick}
        />
        {previewText && (
          <Collapse isOpened={!preview}>
            <p>{previewText}</p>
          </Collapse>
        )}

        <Collapse isOpened={preview}>
          <div
            className="-mx-4 p-4 overflow-hidden"
            hidden={!preview}
            style={style}
          >
            <p>{description}</p>
            <a
              className={classNames('button -big', {
                '-disabled': false
              })}
              href={link}
            >
              {linkText}
            </a>
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default TicketOption
